import React from 'react';

export const OrderState = ({ state, getColorTag }) => {
  return (
    (!!state && <p className={getColorTag(state)}>{state}</p>) || <>-</>
  );
};